import Image from 'next/image'

import { getCategory } from '@/components/modules/business/services/category'
import { isWebsiteLive } from '@/components/modules/business/services/website'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'

interface BusinessCardProps {
  business: Business
  onClick: (business: Business) => void
  showMetadata?: boolean
  activeSubscription?: boolean
}

export function BusinessCard({
  business,
  onClick,
  showMetadata = false,
  activeSubscription = false,
}: BusinessCardProps) {
  const { id, logo, name } = business
  const { website = {} as Website } = business

  const { url, stackStatus } = website || {}

  const category = getCategory(business)

  function formatUrl(url: string | undefined) {
    return (url || '').replace('https://', '')
  }

  return (
    <Card
      key={id}
      className="cursor-pointer hover:shadow-md transition-all duration-200 active:bg-background-active hover:bg-background-active group py-0"
      onClick={() => onClick(business)}
    >
      <CardContent className="p-4">
        <div className="flex items-center space-x-4">
          {/* Business Logo */}
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-background-active rounded-lg border border-light-placeholder overflow-hidden relative">
              {logo && (
                <Image src={logo} alt={name} fill className="object-cover" sizes="48px" />
              )}
            </div>
          </div>

          {/* Business Info */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-base m-0 font-medium text-foreground/90 group-hover:text-primary group-active:text-primary truncate-one-line transition-colors">
                  {name}
                </h3>
                <div className="flex flex-wrap items-center space-x-2 mt-0 max-w-full overflow-hidden">
                  <Badge variant="outline" className="text-xs mt-1">
                    {category}
                  </Badge>
                  {showMetadata && (
                    <>
                      <Badge variant="outline" className="text-xs mt-1">
                        Merchant ID: {id}
                      </Badge>
                    </>
                  )}

                  {activeSubscription && (
                    <Badge variant="primary" className="text-xs mt-1">
                      Active
                    </Badge>
                  )}

                  <Badge
                    variant={isWebsiteLive(website) ? 'primary' : 'outline'}
                    className="text-xs mt-1"
                  >
                    {stackStatus || 'Preview'}
                  </Badge>
                </div>

                {url && (
                  <div className="flex flex-wrap items-center space-x-2 mt-1 max-w-full overflow-hidden">
                    <Badge variant="outline" className="text-xs break-word">
                      {formatUrl(url)}
                    </Badge>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
